module.exports = __webpack_public_path__ + "static/media/Adjunta_credencial_reverso.035ba159.gif";